import { UseQueryResult } from '@tanstack/react-query'

import { ResponseDataShape } from './response'
import { useQuery, Props as UseQueryProps } from './useQuery'

export const useLazyQuery = <
  Variables extends Record<string, unknown>,
  ResponseData extends ResponseDataShape,
  TransformedData = ResponseData,
>({
  onCompleted,
  options,
  query,
  variables,
}: UseQueryProps<Variables, ResponseData>): UseQueryResult & {
  lazyFetch: UseQueryResult<TransformedData>['refetch']
} => {
  const queryProps = useQuery<Variables, ResponseData, TransformedData>({
    onCompleted,
    options: {
      ...options,
      enabled: false,
      staleTime: Infinity,
    },
    query,
    variables,
  })

  return {
    ...queryProps,
    lazyFetch: queryProps.refetch,
  }
}
